module.exports = __webpack_public_path__ + "static/media/advices.2bebdbe2.svg";